import { isMockMode, post, simulateDelay } from "../api";

export const createOrgEnabledProductSub = (data) => {
	if (isMockMode()) {
		const testData = { isValid: true };

		return simulateDelay(50, () => testData);
	}

	return post(`Subscriptions/CreateOrgEnabledProductSub`, data, {
		successMessage: "Subscription successfully created",
	});
};
